import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NodeConfigService } from "src/app/core/services/node-config.service";
import { NodeService } from "src/app/core/services/node.service";
import { HpcConfig } from "../../../../../core/models/node-config";
import { DeploymentService } from "../../../../../core/services/deployment.service";
import { FunctionDispatcherService } from "src/app/core/services/function-dispatcher.service";

@Component({
  selector: 'app-add-node-configurator',
  templateUrl: './add-node-configurator.component.html',
  styleUrls: ['./add-node-configurator.component.scss']
})
export class AddNodeConfiguratorComponent implements OnInit {
  depName: any;
  cloudProviderName: any;
  cloudProviders: any[];

  constructor(
    public dialog: MatDialogRef<AddNodeConfiguratorComponent>,
    public nodeService: NodeService,
    public nodeConfigService: NodeConfigService,
    private snackBar: MatSnackBar,
    private depService: DeploymentService,
    private formComm: FunctionDispatcherService
  ) { }

  isLinear = false;


  cpuDetails: UntypedFormGroup;
  diskDetails: UntypedFormGroup;
  cloudInfraDetails: UntypedFormGroup;
  socketsAndCoreDetails: UntypedFormGroup;
  gpuDetails: UntypedFormGroup;
  rdmaDetails: UntypedFormGroup;


  ngOnInit(): void {

    this.depService.getAllCloudProvidersValueText().subscribe({
      next: (data: any) => {
        if (data) {
          this.cloudProviders = data;
        }
        },
      error: (error) => {
        this.snackBar.open("Failed to fetch cloud provider list, please try again.", "Ok", { duration: 5000 });
        }
    });

    this.cpuDetails = new UntypedFormGroup({
      instanceCode: new UntypedFormControl(null, [Validators.required]),
      cpuCores: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      hpcUnits: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      cpuType: new UntypedFormControl(null, [Validators.required]),
      numofSockets: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      coresPerSocket: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      threadsPerCore: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
    })

    this.diskDetails = new UntypedFormGroup({
      storageSize: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      RAMSize: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      storageType: new UntypedFormControl(null, [Validators.required]),
    })

    this.cloudInfraDetails = new UntypedFormGroup({
      cloudType: new UntypedFormControl(null, [Validators.required]),
    })

    this.socketsAndCoreDetails = new UntypedFormGroup({
    })

    this.gpuDetails = new UntypedFormGroup({
      noOfGpu: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      gpuMemorySize: new UntypedFormControl(null, [Validators.required, Validators.pattern("^[0-9]*$")]),
      gpuModel: new UntypedFormControl(null, [Validators.required]),
    })

    this.rdmaDetails = new UntypedFormGroup({
      isRDMAsupport: new UntypedFormControl(null, [Validators.required]),
    })
  }
  onClose() {
    this.dialog.close(false)
  }
  onSubmit(cpuDetails: UntypedFormGroup, diskDetails: UntypedFormGroup, cloudInfraDetails: UntypedFormGroup,
    soketsAndCoreDetails: UntypedFormGroup, gpuDetails: UntypedFormGroup, rdmaDetails: UntypedFormGroup) {


    if (!cpuDetails.valid) {
      this.cpuDetails.markAllAsTouched();
      return;
    }
    if (!diskDetails.valid) {
      this.diskDetails.markAllAsTouched();
      return;
    }
    if (!cloudInfraDetails.valid) {
      this.cloudInfraDetails.markAllAsTouched();
      return;
    }
    if (!gpuDetails.valid) {
      this.gpuDetails.markAllAsTouched();
      return;
    }
    if (!rdmaDetails.valid) {
      this.rdmaDetails.markAllAsTouched();
      return;
    }
    let nodeConfig: HpcConfig = {
      cpuCores: cpuDetails.value.cpuCores,
      hpcUnits: cpuDetails.value.hpcUnits,
      cpuType: cpuDetails.value.cpuType,
      cloudProvider: cloudInfraDetails.value.cloudType,
      ramSize: diskDetails.value.RAMSize,
      hddType: diskDetails.value.storageType,
      hddSize: diskDetails.value.storageSize,
      isRdmaSupported: JSON.parse(rdmaDetails.value.isRDMAsupport),
      numOfSockets: cpuDetails.value.numofSockets,
      coresPerSocket: cpuDetails.value.coresPerSocket,
      threadsPerCore: cpuDetails.value.threadsPerCore,
      instanceCode: cpuDetails.value.instanceCode,
      maxHpcNodes: 0,
      pricePerHour: 0,
      description: null,
      noOfGPU: gpuDetails.value.noOfGpu,
      gpuMemorySize: gpuDetails.value.gpuMemorySize,
      gpuModel: gpuDetails.value.gpuModel,
      cpuModel: null,
    }

    this.nodeConfigService.addNewNodeConfig(nodeConfig)
      .subscribe({
        next: (data) => {
          this.formComm.triggerFormRefresh({
            refreshForm: true,
            name: nodeConfig?.instanceCode,
            action: 'hpcConfig'
          });
          this.snackBar.open(data.message, "Ok", {
            duration: 5000
          });
          this.dialog.close(true)
        }, error: (err) => {
          this.dialog.close(true)
        }
      })
  }
}
